import { useState } from 'react';
import { toast } from 'react-toastify';
import { useGlobal } from '../../state';
import { Modal, closeHook } from '../modal';
import { Button } from '../input';
import { ApiKey } from './ApiKey';

export const RotateApiKey = (props) => {
  const { fox, setApiKey } = useGlobal();
  const [loading, setLoading] = useState();
  const close = closeHook();

  const handleRotate = async () => {
    setLoading(true);
    const data = await fox.call('POST', '/api/user/rotate-api-key');
    console.log('data', data);
    setLoading(false);
    toast.info('Rotated API key');
    close.trigger();

    setApiKey(data.apiKey);
  };

  return (
    <div>
      <Modal title="Rotate API key" close={close.signal}>
        <Button {...props}>Rotate API Key</Button>

        <div style={{ width: 600 }}>
          <p>Your API key is:</p>

          <ApiKey />

          <p>Rotating your API key will permanently disable this key, and issue a new key.</p>
          <p>
            <b>This action is irreversible.</b>
          </p>

          <div style={{ display: 'flex', gap: 10 }}>
            <Button onClick={handleRotate} loading={loading}>
              Confirm API Key Rotation
            </Button>
            <Button outline onClick={close.trigger}>
              Cancel
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};
